import { render, staticRenderFns } from "./vouchers.vue?vue&type=template&id=5817b924&scoped=true"
import script from "./vouchers.vue?vue&type=script&lang=js"
export * from "./vouchers.vue?vue&type=script&lang=js"
import style0 from "./vouchers.vue?vue&type=style&index=0&id=5817b924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5817b924",
  null
  
)

export default component.exports